import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

function decodeUrlSafeBase64(base64: string): string {
  let standardBase64 = base64.replace(/-/g, '+').replace(/_/g, '/');
  const padding = standardBase64.length % 4;
  if (padding > 0) {
    standardBase64 += '='.repeat(4 - padding);
  }
  return atob(standardBase64);
}

export function encodeQfai(payload: Record<string, unknown>): string {
  return btoa(JSON.stringify(payload));
}

export function decodeQfai<T extends Record<string, unknown> = Record<string, unknown>>(
  qfai: string | null | undefined,
): T | null {
  if (qfai == null || qfai === '') return null;

  try {
    let base64String = qfai;
    if (qfai.startsWith('wlai-')) {
      base64String = qfai.substring(5);
    }

    const decodedString = decodeUrlSafeBase64(base64String);
    return JSON.parse(decodedString) as T;
  } catch {
    return null;
  }
}

export function useQfaiParam<T extends Record<string, unknown> = Record<string, unknown>>(): T | null {
  const [searchParams] = useSearchParams();

  return useMemo(() => decodeQfai<T>(searchParams.get('qfai')), [searchParams]);
}
